import React from 'react';
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SiteProvider } from "@/contexts/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from 'react';

// Pages
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import FundsPage from "@/pages/FundsPage";
import FundDetailPage from "@/pages/FundDetailPage";
import KYCPage from "@/pages/KYCPage";
import AdminPage from "@/pages/AdminPage";
import ContentPage from "@/pages/ContentPage";
import ContactPage from "@/pages/ContactPage";
import DepositPage from "@/pages/DepositPage";
import WithdrawalPage from "@/pages/WithdrawalPage";
import BRInvestPage from "@/pages/BRInvestPage";
import LoanContractPage from "@/pages/LoanContractPage";
import PublicSignPage from "@/pages/PublicSignPage";

// Layout
import Layout from "@/components/Layout";
import SessionWarning from "@/components/SessionWarning";

// Protected Route
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/sign/:token" element={<PublicSignPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="funds" element={<FundsPage />} />
            <Route path="funds/:id" element={<FundDetailPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="kyc"
              element={
                <ProtectedRoute>
                  <KYCPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="page/:slug" element={<ContentPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="deposit" element={<DepositPage />} />
            <Route
              path="withdrawal"
              element={
                <ProtectedRoute>
                  <WithdrawalPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="br-invest"
              element={
                <ProtectedRoute>
                  <BRInvestPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="contracts"
              element={
                <ProtectedRoute>
                  <LoanContractPage />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
        <SessionWarning />
      </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
